export function optimizedImg(src: string, width = 400, quality = 75): string {
  if (!src) return src;
  if (!src.startsWith("/uploads/")) return src;
  const rel = src.replace(/^\/uploads\//, "");
  if (!rel) return src;
  return `/api/img/${rel.split("/").map(encodeURIComponent).join("/")}?w=${width}&q=${quality}`;
}
